const getTypeOfImpact = (initiative) => {
  if (!initiative || !initiative.impact || initiative.impact.length === 0) {
    return '<not set>';
  }

  let type = null; // Initialize type to null

  const hasInterestIncome = initiative.impact.some(
    (i) =>
      i.typeOfImpact === 'Interest Income' ||
      i.typeOfImpact === 'FX Income' ||
      i.typeOfImpact === 'Interest Expense' ||
      i.typeOfImpact === 'FTP on Extra deposits' ||
      i.typeOfImpact === 'Provision net credit losses'
  );
  if (hasInterestIncome) {
    type = 'Customer Specific';
  }

  const hasAmortization = initiative.impact.some(
    (i) => i.typeOfImpact === 'Amortization' || i.typeOfImpact === 'Depreciation'
  );
  if (hasAmortization) {
    type = 'CAPEX';
  }

  if (!type) {
    type = 'OPEX';
  }

  return type;
};
export default getTypeOfImpact;
